import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import SelectInput from "../../widgets/SelectInput";
import Utils from "../../utils/utils";
import getTag from "../../services/getTag";
import addLeads from "../../services/addLeads";
import getCategorieTag from "../../services/getCategorieTag";
import getLeads from "../../services/getLeads";

export default class AddLead extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      testo: "",
      isLoading: false,
      addElementVisible: false,
      nome: "",
      cognome: "",
      mail: "",
      professione: "",
      indirizzo: "",
      documentoIdentita: "",
      citta: "",
      codiceFiscale: "",
      telefono: "",
      eta: "",
      dataIscrizione: "",
      tags: [],
      selectedTags: [],
      categorieTagOptions: [],
      selectedTagsByCategory: {},
    };

    this.pageTitle = "Aggiungi Lead";
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const tags = await getTag(username, token);
    const categorieTag = await getCategorieTag(username, token);
    this.setState({ tags: tags, categorieTagOptions: categorieTag });
  }

  lockedSaveStudente = Utils.disallowConcurrency(this.save.bind(this));

  handleTagChange = (categoriaId, selectedOptions) => {
    this.setState((prevState) => {
      const updatedSelectedTagsByCategory = {
        ...prevState.selectedTagsByCategory,
        [categoriaId]: selectedOptions,
      };
      return { selectedTagsByCategory: updatedSelectedTagsByCategory };
    });
  };

  render() {
    const tagsByCategory = this.state.categorieTagOptions.map((categoria) => {
      const tagsForCategory = this.state.tags.filter(
        (tag) => tag.id_categoria === categoria.id
      );
      return {
        ...categoria,
        tags: tagsForCategory,
      };
    });

    const getFilteredTags = (categoriaId) => {
      const selectedTagsInOtherCategories = Object.values(
        this.state.selectedTagsByCategory
      )
        .flat()
        .filter((tag) => tag !== null && tag !== undefined)
        .map((tag) => tag.value);
      return tagsByCategory
        .find((categoria) => categoria.id === categoriaId)
        .tags.filter((tag) => !selectedTagsInOtherCategories.includes(tag.id));
    };

    const formGridStyle = {
      display: "grid",
      gridTemplateColumns: "1fr 2fr",
      gap: "16px",
    };

    const responsiveGridStyle = (width) => ({
      ...formGridStyle,
      gridTemplateColumns: width > 686 ? "1fr 3fr" : "1fr",
    });

    const formItemStyle = {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    };

    return (
      <div>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle title={this.pageTitle} />

          <div style={responsiveGridStyle(window.innerWidth)}>
            <div style={formItemStyle}>
              <TextInput
                name={"Nome"}
                value={this.state.nome}
                onChange={(text) => this.setState({ nome: text })}
              />
              <TextInput
                name={"Cognome"}
                value={this.state.cognome}
                onChange={(text) => this.setState({ cognome: text })}
              />
              <TextInput
                name={"Mail"}
                value={this.state.mail}
                onChange={(text) => this.setState({ mail: text })}
              />

              <TextInput
                name={"Telefono"}
                value={this.state.telefono}
                onChange={(text) => this.setState({ telefono: text })}
              />
              <TextInput
                name={"Età"}
                value={this.state.eta}
                onChange={(text) => this.setState({ eta: text })}
              />
              <TextInput
                name={"Città"}
                value={this.state.citta}
                onChange={(text) => this.setState({ citta: text })}
              />
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <label style={{ fontSize: "14px", fontWeight: "bold" }}>
                  Data iscrizione
                </label>
                <input
                  type="date"
                  value={this.state.dataIscrizione || ""}
                  onChange={(e) => {
                    const value = e?.target?.value || "";
                    this.setState({ dataIscrizione: value });
                  }}
                  style={{
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>

            <div style={formItemStyle}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                {tagsByCategory.map((categoria) => (
                  <div key={categoria.id}>
                    <SelectInput
                      value={
                        this.state.selectedTagsByCategory[categoria.id] || []
                      }
                      name={categoria.nome}
                      hidable={false}
                      options={getFilteredTags(categoria.id).map((tag) => ({
                        value: tag.id,
                        label: tag.tag,
                      }))}
                      isMulti={true}
                      onChange={(selectedOptions) => {
                        // Logga la categoria e le opzioni selezionate
                        console.log("Categoria:", categoria);
                        console.log("Opzioni selezionate:", selectedOptions);

                        // Gestisci il cambiamento come prima
                        this.handleTagChange(categoria.id, selectedOptions);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <br />
          <br />
          <FixButton
            title={"Salva"}
            callback={this.state.isLoading ? () => {} : this.lockedSaveStudente}
          />
        </LoadingOverlay>
      </div>
    );
  }

  async save() {
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const userType = cookies.get("userType", { path: "/" });

    // ✅ Controllo BLOCCANTE duplicati prima di salvare
    try {
      const existingLeads = await getLeads(username, token);

      // Verifica duplicati per telefono
      const duplicateByPhone =
        this.state.telefono &&
        existingLeads.find(
          (lead) =>
            lead.telefono && lead.telefono.trim() === this.state.telefono.trim()
        );

      // Verifica duplicati per email
      const duplicateByEmail =
        this.state.mail &&
        existingLeads.find(
          (lead) =>
            lead.mail &&
            lead.mail.toLowerCase().trim() ===
              this.state.mail.toLowerCase().trim()
        );

      if (duplicateByPhone || duplicateByEmail) {
        this.setState({ isLoading: false });

        let errorMessage =
          "⚠️ IMPOSSIBILE CREARE IL LEAD\n\nEsiste già un lead con:\n";

        if (duplicateByPhone) {
          errorMessage += `\n• Telefono: "${this.state.telefono}"`;
          errorMessage += `\n  Nome esistente: ${duplicateByPhone.nome ||
            ""} ${duplicateByPhone.cognome || ""}`;
        }

        if (duplicateByEmail) {
          errorMessage += `\n• Email: "${this.state.mail}"`;
          errorMessage += `\n  Nome esistente: ${duplicateByEmail.nome ||
            ""} ${duplicateByEmail.cognome || ""}`;
        }

        errorMessage += "\n\n❌ MODIFICA I DATI PRIMA DI SALVARE";

        alert(errorMessage);
        return; // Blocca completamente la creazione
      }
    } catch (error) {
      console.error("Errore durante il controllo duplicati:", error);
      this.setState({ isLoading: false });
      alert("Errore durante il controllo duplicati. Impossibile procedere.");
      return;
    }

    const allSelectedTags = Object.values(this.state.selectedTagsByCategory)
      .flat()
      .filter((tag) => tag !== null && tag !== undefined)
      .map((tag) => tag.value)
      .join(",");

    let ret = await addLeads(
      username,
      token,
      this.state.cognome,
      this.state.nome,
      this.state.mail,
      allSelectedTags,
      this.state.telefono,
      this.state.dataIscrizione,
      this.state.eta,
      this.state.citta
    );

    if (ret.result === "ok") {
      this.setState({ isLoading: false });
      if (userType == 4) return (window.location.href = "/#/app/daChiamare");
      window.location.href = "/#/app/leads";
    } else {
      this.setState({ isLoading: false });
      alert(
        "Si è verificato un errore durante la creazione. Per favore, riprova."
      );
    }
  }
}
